// extracted by mini-css-extract-plugin
export default {"result":"result__vvvkrN","resultText":"resultText__uA5HiB","actionButton":"actionButton__i7dr9n"};